import distributionService from "../../services/DistributionService";
import XLSX from "xlsx";
export default {
    data() {
        return {
            data: [],
            loading: true,
            consecutive: null,
            format: [],
            headers: [{
                    text: "FECHA DE ENTREGA",
                    sortable: false,
                    value: "deliveryDate"
                },
                {
                    text: "CONSECUTIVO",
                    sortable: false,
                    value: "states"
                },
                {
                    text: 'FECHA DE PLANILLA',
                    sortable: false,
                    value: 'scheduleRange'
                },
                {
                    text: "DESCARGAR",
                    sortable: false,
                    value: "dowload"
                }
            ],
            searchDate: new Date().toISOString().substr(0, 10)
        };
    },

    props: {
        onRowClick: {
            type: Function,
            default: () => {}
        }
    },
    methods: {
        searchField() {
            distributionService.uploadOrder(this.searchDate).then(response => {
                this.data = response.data[0];
                this.loading = true;
            });
        },
        clearSearch() {
            this.searchDate = null;
            this.data = [];
        },
        uploadOrderMethod(id) {
            distributionService.downloadDoc(id).then(response => {
                console.log(response.data);
                this.format.push(id);
                var columns = XLSX.utils.json_to_sheet(response.data);

                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, columns, "Planilla");
                XLSX.writeFile(
                    wb,
                    `farmadomicilios_planilla_distribucion_${this.searchDate
            .split("-")
            .join("")}.xlsx`
                );
            });
        }
    }
};